var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rogue.show)?_c('y-rogue-wrapper',_vm._g(_vm._b({attrs:{"name":_vm.rogue.slug,"type":_vm.rogue.type},on:{"back":_vm.backToLogin}},'y-rogue-wrapper',_vm.rogue.props,false),_vm.rogue.listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }